import { LicenseStudyAreas } from "src/app/predictor-enterprise-license/shared/interface/License-Study-Areas";

export namespace LicenseStudyAreaActions {
  export class GetAll {
    static readonly type = '[LicenseStudyArea] Get All';
  }

  export class GetById {
    static readonly type = '[LicenseStudyArea] Get By ID';
    constructor(public id: string) {}
  }

  export class Create {
    static readonly type = '[LicenseStudyArea] Create';
    constructor(public studyArea: LicenseStudyAreas) {}
  }

  export class Update {
    static readonly type = '[LicenseStudyArea] Update';
    constructor(public id: string, public studyArea: LicenseStudyAreas) {}
  }

  export class Delete {
    static readonly type = '[LicenseStudyArea] Delete';
    constructor(public id: string) {}
  }

  export class SetStep {
    static readonly type = '[LicenseStudyArea] Set Step';
    constructor(public step: number) {}
  }

  export class SetSelected {
    static readonly type = '[LicenseStudyArea] Set Selected';
    constructor(public studyArea: LicenseStudyAreas) {}
  }

  export class CheckUniqueStudyAreaName {
    static readonly type = '[LicenseStudyArea] Check Unique Name';
    constructor(public studyAreaName: string, public licenseNumber: string) {}
  }
}